//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, ConciergeProxy, SagasHelper, RabbitListener, LogsProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

import PerfilManager from '../../../Common/Managers/PerfilManager';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES
export const GET_SCREEN_DATA_PERFYPERM_STARTS = "GET_SCREEN_DATA_PERFYPERM_STARTS";
export const SET_USER_FUNCTIONS_PERFYPERM = "SET_USER_FUNCTIONS_PERFYPERM";
export const GET_SCREEN_DATA_PERFYPERM_SUCCESS = "GET_SCREEN_DATA_PERFYPERM_SUCCESS";
export const RESET_STATE_PERFYPERM = 'RESET_STATE_PERFYPERM';
export const SELECT_PRODUCTO_PERFYPERM = 'SELECT_PRODUCTO_PERFYPERM';
export const SELECT_CATEGORIA_PERFYPERM = 'SELECT_CATEGORIA_PERFYPERM';
export const SELECT_PROGRAMA_PERFYPERM = 'SELECT_PROGRAMA_PERFYPERM';
export const SET_PERFIL_EDICION = 'SET_PERFIL_EDICION';
export const SET_PERFIL_SELECCIONADO = 'SET_PERFIL_SELECCIONADO';
export const ELIMINACION_PERFIL_SUCCESS = 'ELIMINACION_PERFIL_SUCCESS';
export const SET_SAVE_ERROR_MSG_PERFYPERM = 'SET_SAVE_ERROR_MSG_PERFYPERM';
export const CREATE_PERFIL_RESULT = 'CREATE_PERFIL_RESULT';
export const LIMPIAR_MENSAJES_PERFYPERM = 'LIMPIAR_MENSAJES_PERFYPERM';
export const SET_EDIT_ERROR_MSG_PERFYPERM = 'SET_EDIT_ERROR_MSG_PERFYPERM';
export const EDIT_PERFIL_RESULT = 'EDIT_PERFIL_RESULT';
export const ESCONDER_POPUP_PERFYPERM = 'ESCONDER_POPUP_PERFYPERM';
export const SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS = 'SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS';
export const DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS = 'DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS';
export const SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT = 'SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT';
export const DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT = 'DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT';
export const STOP_CLEAR_POP_UP_DATA_PERFYPERM = 'STOP_CLEAR_POP_UP_DATA_PERFYPERM';
export const START_CLEAR_POP_UP_DATA_PERFYPERM = 'START_CLEAR_POP_UP_DATA_PERFYPERM';
export const SET_POP_UP_PERFYPERM = 'SET_POP_UP_PERFYPERM';
export const BUSCAR_PERFIL = 'BUSCAR_PERFIL';

let _dispatch, _currentScope = null;
let _globalParams, _perfilesAD = null;

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch) => {
        _currentScope = currentScope;
        _dispatch = dispatch;
        dispatch({ type: GET_SCREEN_DATA_PERFYPERM_STARTS });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenDataCallback(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }
}

/**
 * Vuelve el estado de la pantalla al inicial de la misma.
 */
export function resetStatePerfyPerm() {
    LogHelper.In(resetStatePerfyPerm.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_PERFYPERM });
    }
}

export function buscarPerfil(palabra) {
    LogHelper.In(resetStatePerfyPerm.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: BUSCAR_PERFIL, palabra: palabra });
    }
}


/**
 * Filtra la categoria en cascada, dependiendo del producto seleccionado.
 * @param {any} id
 */
export function selectProducto(id) {
    LogHelper.In(selectProducto.name, id);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_PRODUCTO_PERFYPERM, id });
    }
}

/**
 * Filtra el programa en cascada, dependiendo de la categoria seleccionada.
 * @param {any} id
 */
export function selectCategoria(id) {
    LogHelper.In(selectCategoria.name, id);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_CATEGORIA_PERFYPERM, id });
    }
}

/**
 * Actualiza el state a partir de un grupo de windows seleccionado
 * @param {any} id
 */
export function addGroupWindows(id) {
    LogHelper.In(addGroupWindows.name, id);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS, id });
    }
}

/**
 * Actualiza el state a partir de un grupo de windows de-seleccionado
 * @param {any} id
 */
export function deleteGroupWindows(id) {
    LogHelper.In(deleteGroupWindows.name, id);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS, id });
    }
}

/**
 * Actualiza el state a partir de un grupo de windows seleccionado
 * @param {any} idGrupo
 * @param {any} idPerfil
 */
export function addGroupWindowsEdit(idGrupo, idPerfil) {
    LogHelper.In(addGroupWindowsEdit.name, idGrupo, idPerfil);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT, idGrupo, idPerfil });
    }
}

/**
 * Actualiza el state a partir de un grupo de windows de-seleccionado
 * @param {any} idGrupo
 * @param {any} idPerfil
 */
export function deleteGroupWindowsEdit(idGrupo, idPerfil) {
    LogHelper.In(deleteGroupWindowsEdit.name, idGrupo, idPerfil);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT, idGrupo, idPerfil });
    }
}

/**
 * Obtiene los permisos, para las funcionalidades en pantalla, dependiendo del filtro de programa seleccionado.
 * @param {any} id
 */
export function selectPrograma(id) {
    LogHelper.In(selectPrograma.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().perfilesyPermisos));
        let localValue = {
            'PRODUCT_ID': state.filter.product,
            'CATEGORY_ID': state.filter.category,
            'PROGRAM_ID': id
        }

        LogHelper.Out(selectPrograma.name, localValue, 'GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
        Engine1Proxy.Execute((data) => _funcionalidadesCallback(data, id), null, null, "SEGURIDAD");
    }
}

/**
 * Desplega modal para la edicion del nombre del perfil.
 * @param {any} id
 * @param {any} gruposWindows
 */
export function setPerfilEdicion(id, gruposWindows) {
    LogHelper.In(setPerfilEdicion.name, id, gruposWindows);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SET_PERFIL_EDICION, id, gruposWindows });

        $("#editProfileModal").modal();
    }
}

/**
 * Obtiene los datos relacionados al perfil que se eliminara.
 * @param {any} id
 */
export function setInfoPerfilToDelete(id) {
    LogHelper.In(setInfoPerfilToDelete.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().perfilesyPermisos));
        let profileDescription = state.perfiles.find(x => x.Id == id).Descripcion;

        let localValue = {
            'PROFILE_ID': id
        }

        LogHelper.Out(setInfoPerfilToDelete.name, localValue, "GET_FUNCIONALIDAD_BY_PERFIL", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_FUNCIONALIDAD_BY_PERFIL', "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        LogHelper.Out(setInfoPerfilToDelete.name, localValue, "GET_CANTIDAD_USUARIOS_PERFIL", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_CANTIDAD_USUARIOS_PERFIL', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');

        LogHelper.Out(setInfoPerfilToDelete.name, localValue, "GET_PRODUCTO_BY_PERFIL", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PRODUCTO_BY_PERFIL', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');

        Engine1Proxy.Execute((data) => _infoPerfilCallback(data, id, profileDescription), null, null, "SEGURIDAD");
    }
}

/**
 * Realiza la eminacion del perfil una vez confirmada esta accion.
 */
export function eliminarPerfil() {
    LogHelper.In(eliminarPerfil.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().perfilesyPermisos));

        $("#deleteProfileModal").modal('toggle');
        _dispatch({ type: GET_SCREEN_DATA_PERFYPERM_STARTS });

        PerfilManager.DeletePerfil(state.profileSelected, SagasHelper.GetSagasId, (result, disconectCallback) => ejecutarPorEstadoDelete(result, disconectCallback, state.profileSelected.descripcion));
    }
}

/**
 * Setea los parametros globales para el alta de un nuevo perfil.
 * @param {any} nombre
 * @param {any} productoId
 * @param {any} perfilId
 * @param {any} tipoCopia
 * @param {any} descripcion
 */
export function nuevoPerfil(nombre, productoId, perfilId, tipoCopia, descripcion) {
    LogHelper.In(nuevoPerfil.name, nombre, productoId, perfilId, tipoCopia, descripcion);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().perfilesyPermisos));

        _globalParams = {
            nombre,
            productoId,
            perfilId,
            nuevoPerfil: undefined,
            tipoCopia,
            state,
            descripcion
        }

        _nuevoPerfil(state.gruposWindows, (state.configuracionSesion.VincularGrupoWindows == true &&
            state.configuracionSesion.TipoSeguridad == 'AD'));
    }
}

/**
 * Limpia msj de errores de alta o edición de perfil.
 */
export function limpiarMensajes() {
    LogHelper.In(limpiarMensajes.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: LIMPIAR_MENSAJES_PERFYPERM });
    }
}

/**
 * Frena el limpiado del popup de alta para no entrar en un loop.
 */
export function stopClear() {
    LogHelper.In(stopClear.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: STOP_CLEAR_POP_UP_DATA_PERFYPERM });
    }
}

/**
 * Inicio el limpiado del popup de alta.
 */
export function startClear() {
    LogHelper.In(startClear.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: START_CLEAR_POP_UP_DATA_PERFYPERM });
    }
}

/**
 * Funcion para renombrar un perfil.
 * @param {any} nombre
 * @param {any} nuevoNombre
 * @param {any} descripcion
 * @param {any} nuevaDescripcion
 * @param {any} productoId
 * @param {any} gruposWindows
 * @param {any} altaAutomatica
 */
export function editarPerfil(nombre, nuevoNombre, descripcion, nuevaDescripcion, productoId, gruposWindows, altaAutomatica) {
    LogHelper.In(editarPerfil.name, nombre, nuevoNombre, descripcion, nuevaDescripcion, productoId, gruposWindows, altaAutomatica);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = JSON.parse(JSON.stringify(getState().perfilesyPermisos));

        _editarPerfil(nombre, nuevoNombre, descripcion, nuevaDescripcion, state, productoId, gruposWindows, altaAutomatica);
    }
}

/**
 * Esconde el popup.
 */
export function hidePopUp() {
    LogHelper.In(hidePopUp.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ESCONDER_POPUP_PERFYPERM });
    }
}

/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

/**
 * Funcion callback de las funciones de seguridad.
 * @param {any} data
 */
function _loadScreenDataCallback(data) {
    LogHelper.In(_loadScreenDataCallback.name, data);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_USER_FUNCTIONS_PERFYPERM, functions });

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PRODUCTOS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PRODUCTOS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_CATEGORIAS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_CATEGORIAS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PROGRAMAS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROGRAMAS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PERFILES', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PERFILES', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_PERFIL_GRUPO_WINDOWS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PERFIL_GRUPO_WINDOWS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    LogHelper.Out(_loadScreenDataCallback.name, null, 'GET_CONFIGURATION_PASSWORD_TYPE', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_CONFIGURATION_PASSWORD_TYPE', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    Engine1Proxy.Execute(_loadPerfyPermInitialStateCallback, null, null, "SEGURIDAD");
}

/**
 * Funcion callback de los datos principales para popular la pantalla.
 * @param {any} data
 */
function _loadPerfyPermInitialStateCallback(data) {
    LogHelper.In(_loadPerfyPermInitialStateCallback.name, data);

    let result = {
        GET_PRODUCTOS: JSON.parse(data.GET_PRODUCTOS).Recordset0.Rows,
        GET_CATEGORIAS: JSON.parse(data.GET_CATEGORIAS).Recordset0.Rows,
        GET_PROGRAMAS: JSON.parse(data.GET_PROGRAMAS).Recordset0.Rows,
        GET_PERFILES: JSON.parse(data.GET_PERFILES).Recordset0.Rows,
        GET_PERFIL_GRUPO_WINDOWS: JSON.parse(data.GET_PERFIL_GRUPO_WINDOWS).Recordset0.Rows,
        GET_CONFIGURATION_PASSWORD_TYPE: JSON.parse(data.GET_CONFIGURATION_PASSWORD_TYPE).Recordset0.Rows[0],
        GET_GRUPOS_WINDOWS: []
    }

    result.GET_PRODUCTOS.unshift({ Id: 0, Descripcion: "Producto..." });
    result.GET_CATEGORIAS.unshift({ Id: 0, Descripcion: "Categoria..." });
    result.GET_PROGRAMAS.unshift({ Id: 0, Descripcion: "Programa..." });

    for (var i = 0; i < result.GET_PERFILES.length; i++) {
        result.GET_PERFILES[i].first = (i == 0);
        result.GET_PERFILES[i].functions = [];
        result.GET_PERFILES[i].gruposWindows = [];
    }

    _perfilesAD = (result.GET_CONFIGURATION_PASSWORD_TYPE.TipoSeguridad == "AD");

    //Si el alta automática está activada, busca los grupos de AD
    if (_perfilesAD == true) {
        LogHelper.Out(_loadPerfyPermInitialStateCallback.name, null, 'GET_ALL_GROUPS_AD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ALL_GROUPS_AD', "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

        Engine1Proxy.Execute((data) => _loadGrupoWindows(data, result), null, null, "SEGURIDAD");
    }
    else {
        _dispatch({ type: GET_SCREEN_DATA_PERFYPERM_SUCCESS, result });
    }
}

/**
 * Dispacha el resultado al cargarse grupos de AD en el load
 * @param {any} data
 * @param {any} result
 */
function _loadGrupoWindows(data, result) {
    LogHelper.In(_loadGrupoWindows.name, data, result);

    let gruposWindows = [];

    //Valido si hubo error en la consulta de AD.
    let ADResult = JSON.parse(data.GET_ALL_GROUPS_AD).Recordset0.Rows[0];

    if (ADResult.IsError) {
        gruposWindows = [{ Id: 0, Descripcion: ADResult.Message, Selected: false }];
    }
    else {
        //Mapeo de grupos de AD.        
        ADResult = JSON.parse(ADResult.Result);
        ADResult.forEach((g, index) => {
            gruposWindows.push({ Id: index, Descripcion: g, Selected: false });
        });
    }

    result.GET_GRUPOS_WINDOWS = gruposWindows;

    for (var i = 0; i < result.GET_PERFILES.length; i++) {
        result.GET_PERFILES[i].gruposWindows = JSON.parse(JSON.stringify(gruposWindows));

        result.GET_PERFILES[i].gruposWindows.forEach(function (grupo) {
            result.GET_PERFIL_GRUPO_WINDOWS.forEach(function (existingRelation) {
                if (grupo.Descripcion == existingRelation.GrupoWindows && existingRelation.IdPerfil == result.GET_PERFILES[i].Id)
                    grupo.Selected = true;
            });
        });
    }

    _dispatch({ type: GET_SCREEN_DATA_PERFYPERM_SUCCESS, result });    
}

/**
 * Funcion callback de la obtencion de las funcionalidades para un perfil.
 * @param {any} data
 * @param {any} id
 */
function _funcionalidadesCallback(data, id) {
    LogHelper.In(_funcionalidadesCallback.name, data, id);

    let funcionalidades = JSON.parse(data.GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD).Recordset0.Rows;

    _dispatch({ type: SELECT_PROGRAMA_PERFYPERM, id, funcionalidades });
}

/**
 * Setea datos de perfil a eliminar y muestra modal de confirmación.
 * @param {any} data
 * @param {any} id
 * @param {any} descripcion
 */
function _infoPerfilCallback(data, id, descripcion) {
    LogHelper.In(_infoPerfilCallback.name, data, id);

    var productList = JSON.parse(data.GET_PRODUCTO_BY_PERFIL).Recordset0.Rows;

    let profileSelected = {
        id: id,
        userCount: JSON.parse(data.GET_CANTIDAD_USUARIOS_PERFIL).Recordset0.Rows[0].CountUsers,
        descripcion: descripcion,
        functionalities: JSON.parse(data.GET_FUNCIONALIDAD_BY_PERFIL).Recordset0.Rows,
        products: productList,
        productoId: productList.length == 0 ? 0 : productList[0].Id
    };

    _dispatch({ type: SET_PERFIL_SELECCIONADO, profileSelected });

    $("#deleteProfileModal").modal();
}

/**
 * Funcion callback de la eliminacion de un perfil.
 * @param {any} data
 * @param {any} descripcion
 */
function _eliminarPerfilCallback(descripcion) {
    LogHelper.In(_eliminarPerfilCallback.name, descripcion);

    LogsProxy.SaveOperationLog("SEGURIDAD,BAJA,PERFIL", "Baja del perfil " + descripcion,
        null, null, eliminarPerfilLogCallback, null, null, "SEGURIDAD");        
}

/**
 * Callback del logeo al eliminar un perfil
 * @param {any} data
 */
function eliminarPerfilLogCallback(data) {
    LogHelper.In(eliminarPerfilLogCallback.name, data);

    _dispatch({ type: ELIMINACION_PERFIL_SUCCESS });
}

/**
 * Da de alta a un nuevo perfil.
 * @param {any} gruposWindows
 * @param {any} altaAutomatica
 */
function _nuevoPerfil(gruposWindows, altaAutomatica) {
    LogHelper.In(_nuevoPerfil.name, gruposWindows, altaAutomatica);

    let newId;
    let nameContain = false;
    let saveErrorMessage = "";
    let saveDescripcionErrorMessage = "";
    let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    let formatDescripcion = /[!@#$%^&*()_+\-=\[\]{};':"\\|<>\/?~]/;
    let grupoSelected = false;
    let isError = false;

    gruposWindows.forEach(function (group) {
        if (group.Selected) {
            grupoSelected = true;
        }
    });
    _globalParams.nombre = _globalParams.nombre.trim();
    if ((grupoSelected && altaAutomatica) || !altaAutomatica) {

        if (_globalParams.nombre !== "" && _globalParams.nombre !== undefined) {

            if (_globalParams.descripcion !== "" && _globalParams.descripcion !== undefined) {

                if (!format.test(_globalParams.nombre)) {

                    if (!formatDescripcion.test(_globalParams.descripcion)) {

                        _globalParams.state.perfiles.map(function (row) {
                            if (row.Codigo.toLowerCase() == _globalParams.nombre.toLowerCase()) {
                                nameContain = true;
                                return;
                            }
                        });

                        if (!nameContain && _globalParams.descripcion) {
                            let profile = {
                                'CODIGO': _globalParams.nombre,
                                'DESCRIPCION': _globalParams.descripcion,
                                'GRUPOS_WINDOWS': gruposWindows.filter(x => x.Selected),
                                'PRODUCTO_ID': _globalParams.productoId
                            }

                            _dispatch({ type: GET_SCREEN_DATA_PERFYPERM_STARTS });
                            $("#newProfileModal").modal('toggle');

                            _getFuncionalidades(profile);
                        }
                        else {
                            if (nameContain) {
                                isError = true;
                                saveErrorMessage = "El nombre de perfil ya existe.";
                            }

                            if (!_globalParams.descripcion) {
                                isError = true;
                                saveDescripcionErrorMessage = "Debe ingresar una descripción para el nuevo perfil.";
                            }
                        }
                    } else {
                        isError = true;
                        saveDescripcionErrorMessage = "La descripción no debe contener caracteres especiales.";
                    }
                } else {
                    isError = true;
                    saveErrorMessage = "El nombre no debe contener caracteres especiales.";
                }
            } else {
                isError = true;
                saveDescripcionErrorMessage = "Debes escribir una descripción para el perfil.";
            }
        }
        else {
            isError = true;
            saveErrorMessage = "Debes escribir un nombre de perfil.";
        }
    } else {
        isError = true;
        saveErrorMessage = "Debe seleccionar al menos un grupo de windows.";
    }

    if (isError)
        _dispatch({ type: SET_SAVE_ERROR_MSG_PERFYPERM, saveErrorMessage, saveDescripcionErrorMessage });
}

function _getFuncionalidades(profile) {
    if (_globalParams.tipoCopia != 0) {
        let param = {};

        if (_globalParams.tipoCopia == 1) {
            param = { 'PROFILE_ID': _globalParams.perfilId }

            LogHelper.Out(_getFuncionalidades.name, param, "GET_FUNCIONALIDAD_BY_PERFIL", "Get",
                _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_FUNCIONALIDAD_BY_PERFIL', "Get",
                _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

            Engine1Proxy.Execute((data) => _getFuncionalidadCallback(data, profile), null, null, "SEGURIDAD");
        }
        else if (_globalParams.tipoCopia == 2) {
            param = {
                'PERFIL_ID': _globalParams.perfilId,
                'PRODUCTO_ID': _globalParams.state.filter.product,
                'CATEGORIA_ID': _globalParams.state.filter.category,
                'PROGRAMA_ID': _globalParams.state.filter.program
            }

            LogHelper.Out(_getFuncionalidades.name, param, "GET_FUNCIONALIDAD_BY_FUNCION", "Get",
                _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_FUNCIONALIDAD_BY_FUNCION', "Get",
                _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

            Engine1Proxy.Execute((data) => _getFuncionalidadCallback(data, profile), null, null, "SEGURIDAD");
        }
    } else {
        profile["FUNCIONALIDAD"] = [];

        _globalParams.nuevoPerfil = profile;

        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios');
        }

        LogHelper.Out(_getFuncionalidades.name);
        PerfilManager.CreatePerfil(profile, SagasHelper.GetSagasId, ejecutarPorEstado);
    }
}

/**
 * Inserta los permisos del perfil creado.
 * @param {any} data
 */
function _getFuncionalidadCallback(data,profile) {
    LogHelper.In(_getFuncionalidadCallback.name, data);

    let idFuncionalidad = data;
    let listFunctionalities = "";

    switch (_globalParams.tipoCopia) {
        case 1:
            listFunctionalities = JSON.parse(data.GET_FUNCIONALIDAD_BY_PERFIL).Recordset0.Rows;
            break;
        case 2:
            listFunctionalities = JSON.parse(data.GET_FUNCIONALIDAD_BY_FUNCION).Recordset0.Rows;
            break;
    }

    let functionalities = [];
    listFunctionalities.forEach(function (funcionalidad) {
        let params = {
            'FUNCIONALIDAD_ID': funcionalidad.Id,
            'ID_PERFIL': null
        }

        functionalities.push(params);
    });

    profile["FUNCIONALIDAD"] = functionalities;

    _globalParams.nuevoPerfil = profile;

    LogHelper.Out(_getFuncionalidadCallback.name);
    PerfilManager.CreatePerfil(profile, SagasHelper.GetSagasId, ejecutarPorEstado);
}

/**
 * Callback de la creación de la relación perfil-producto.
 */
function _perfiProductoCallback() {
    LogHelper.In(_perfiProductoCallback.name);

    LogHelper.Out(_perfiProductoCallback.name, LogsProxy.SaveOperationLog.name, "ALTA,PERFIL");
    LogsProxy.SaveOperationLog("SEGURIDAD,ALTA,PERFIL", "Alta del perfil " + _globalParams.descripcion, null, null, nuevoPerfilLogCallback, null, null, "SEGURIDAD");
}

/**
 * Callback del logeo al dar de alta un perfil
 * @param {any} data
 */
function nuevoPerfilLogCallback(data) {
    LogHelper.In(nuevoPerfilLogCallback.name, data);

    if (_globalParams.state.filter.product > 0 && _globalParams.state.filter.category > 0 && _globalParams.state.filter.program > 0) {
        let localValue = {
            'PRODUCT_ID': _globalParams.state.filter.product,
            'CATEGORY_ID': _globalParams.state.filter.category,
            'PROGRAM_ID': _globalParams.state.filter.program
        }

        LogHelper.Out(nuevoPerfilLogCallback.name, localValue, "GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    }

    LogHelper.Out(nuevoPerfilLogCallback.name, null, "GET_PERFILES", "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PERFILES', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');

    LogHelper.Out(nuevoPerfilLogCallback.name, null, 'GET_PERFIL_GRUPO_WINDOWS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PERFIL_GRUPO_WINDOWS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    //Si el alta automática está activada, busca los grupos de AD
    if (_perfilesAD == true) {
        LogHelper.Out(nuevoPerfilLogCallback.name, null, 'GET_ALL_GROUPS_AD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ALL_GROUPS_AD', "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
    }

    Engine1Proxy.Execute(_cargarNuevoPerfil, null, null, "SEGURIDAD");
}

/**
 * Arma el nuevo perfil para guardarse en memoria, y setea mensajes de exito. Cierra el modal de alta.
 * @param {any} data
 */
function _cargarNuevoPerfil(data) {
    LogHelper.In(_cargarNuevoPerfil.name, data);    

    let result = JSON.parse(data.GET_PERFILES).Recordset0.Rows;
    let activate = false;
    let functionality = [];
    let gruposWindows = [];

    let GET_PERFIL_GRUPO_WINDOWS = JSON.parse(data.GET_PERFIL_GRUPO_WINDOWS).Recordset0.Rows;

    for (var i = 0; i < result.length; i++) {
        result[i].first = (i == 0);
        result[i].functions = [];
    }

    //Valido si se hizo o hubo error en la consulta de AD.
    if (data.GET_ALL_GROUPS_AD) {
        let ADResult = JSON.parse(data.GET_ALL_GROUPS_AD).Recordset0.Rows[0];

        if (ADResult.IsError) {
            gruposWindows = [{ Id: 0, Descripcion: ADResult.Message, Selected: false }];
        }
        else {
            //Mapeo de grupos de AD.        
            ADResult = JSON.parse(ADResult.Result);
            ADResult.forEach((g, index) => {
                gruposWindows.push({ Id: index, Descripcion: g, Selected: false });
            });
        }
    }

    for (var i = 0; i < result.length; i++) {
        result[i].gruposWindows = JSON.parse(JSON.stringify(gruposWindows));
        result[i].gruposWindows.forEach(function (grupo) {
            GET_PERFIL_GRUPO_WINDOWS.forEach(function (existingRelation) {
                if (grupo.Descripcion == existingRelation.GrupoWindows && existingRelation.IdPerfil == result[i].Id)
                    grupo.Selected = true;
            });
        });
    }

    let perfilName =  _globalParams.nombre;
    let message = "El perfil " + perfilName + " fué creado";

    if (data.GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD) {
        functionality = JSON.parse(data.GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD).Recordset0.Rows;
        activate = true;
    }

    if (functionality.length > 0) {
        result.forEach(function (perfil) {
            perfil.functions = functionality.filter(x => x.PerfilId == perfil.Id);
        });
    }
    else {
        result.forEach(function (perfil) {
            perfil.functions = [];
        });
    }

    let response = {
        perfiles: result,
        message,
        activate
    }

    _dispatch({ type: CREATE_PERFIL_RESULT, response });    
}

/**
 * Edita el nombre de un perfil existente.
 * @param {any} nombre
 * @param {any} nuevoNombre
 * @param {any} descripcion
 * @param {any} nuevaDescripcion
 * @param {any} state
 * @param {any} productoId
 * @param {any} gruposWindows
 * @param {any} altaAutomatica
 */
function _editarPerfil(nombre, nuevoNombre, descripcion, nuevaDescripcion, state, productoId, gruposWindows, altaAutomatica) {
    LogHelper.In(_editarPerfil.name, nombre, nuevoNombre, descripcion, nuevaDescripcion, state, productoId, gruposWindows, altaAutomatica);

    let nameContain = false;
    let editErrorMessage = "";
    let editErrorMessageDescripcion = "";
    let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    let formatDescripcion = /[!@#$%^&*()_+\-=\[\]{};':"\\|<>\/?~]/;
    let grupoSelected = false;
    let isError = false;

    gruposWindows.forEach(function (group) {
        if (group.Selected) {
            grupoSelected = true;
        }
    });

    if ((grupoSelected && altaAutomatica) || !altaAutomatica) {

        if (nuevoNombre !== "" && nuevoNombre !== undefined) {

            if (nuevaDescripcion !== "" && nuevaDescripcion !== undefined) {

                if (!format.test(nuevoNombre)) {

                    if (!formatDescripcion.test(nuevaDescripcion)) {

                        let nameContain = true;

                        state.perfiles.map(function (row) {
                            if (row.Codigo.toLowerCase() == nuevoNombre.toLowerCase() && row.Id != state.profileSelected.id) {
                                nameContain = false;
                                return;
                            }
                        });

                        if (nameContain == true) {
                            let param = {
                                'ID': state.profileSelected.id,
                                'CODIGO': nuevoNombre,
                                'DESCRIPCION': nuevaDescripcion,
                                'PRODUCTO_ID': productoId,
                                'GRUPOS_WINDOWS': gruposWindows.filter(x => x.Selected)
                            }

                            _dispatch({ type: GET_SCREEN_DATA_PERFYPERM_STARTS });
                            $("#editProfileModal").modal('toggle');

                            LogHelper.Out(_editarPerfil.name);
                            PerfilManager.EditPerfil(param, SagasHelper.GetSagasId, (result, disconectCallback) => ejecutarPorEstadoEdit(result, disconectCallback, state));
                        }
                        else {
                            isError = true;
                            editErrorMessage = "El nombre de perfil ya existe.";
                        }
                    } else {
                        isError = true;
                        editErrorMessageDescripcion = "El campo descripción no debe contener caracteres especiales.";
                    }
                } else {
                    isError = true;
                    editErrorMessage = "El nombre no debe contener caracteres especiales.";
                }
            } else {
                isError = true;
                editErrorMessageDescripcion = "Debes escribir una descripción para el perfil.";
            }
        } else {
            isError = true;
            editErrorMessage = "Debes escribir un nombre de perfil.";
        }
    } else {
        isError = true;
        editErrorMessage = "Debe seleccionar al menos un grupo de windows.";
    }

    if (isError)
        _dispatch({ type: SET_EDIT_ERROR_MSG_PERFYPERM, editErrorMessage, editErrorMessageDescripcion });
}

/**
 * Callback de la edicion de un perfil.
 * @param {any} data
 * @param {any} state
 */
function _editarPerfilCallback(state) {
    LogHelper.In(_editarPerfilCallback.name, state);

    LogHelper.Out(_editarPerfilCallback.name, LogsProxy.SaveOperationLog.name, "MODIFICACION,PERFIL");
    LogsProxy.SaveOperationLog("SEGURIDAD,MODIFICACION,PERFIL", "Modificación del perfil " +
        state.profileSelected.descripcion, null, null, () => editarPerfilLogCallback(state), null, null, "SEGURIDAD");
}

/**
 * Callback del logeo al modificar un usuario
 * @param {any} data
 * @param {any} state
 */
function editarPerfilLogCallback(state) {
    LogHelper.In(editarPerfilLogCallback.name, state);

    
    if (state.filter.product > 0 && state.filter.category > 0 && state.filter.program > 0) {
        let localValue = {
            'PRODUCT_ID': _ScreenData.filter.product,
            'CATEGORY_ID': _ScreenData.filter.category,
            'PROGRAM_ID': _ScreenData.filter.program
        }

        LogHelper.Out(editarPerfilLogCallback.name, localValue, "GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD", "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    }
    

    LogHelper.Out(editarPerfilLogCallback.name, null, "GET_PERFILES", "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PERFILES', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');

    LogHelper.Out(editarPerfilLogCallback.name, null, 'GET_PERFIL_GRUPO_WINDOWS', 'Get',
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PERFIL_GRUPO_WINDOWS', "Get",
        _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");

    //Si el alta automática está activada, busca los grupos de AD
    if (_perfilesAD == true) {
        LogHelper.Out(editarPerfilLogCallback.name, null, 'GET_ALL_GROUPS_AD', 'Get',
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ALL_GROUPS_AD', "Get",
            _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, "Product");
    }

    Engine1Proxy.Execute(_cargarPerfilEditado, null, null, "SEGURIDAD");
}

/**
 * Arma el perfil editado para guardarse en memoria, y setea mensajes de exito. Cierra el modal de edición.
 * @param {any} data
 */
function _cargarPerfilEditado(data) {
    LogHelper.In(_cargarPerfilEditado.name, data);

    let result = JSON.parse(data.GET_PERFILES).Recordset0.Rows;
    let GET_PERFIL_GRUPO_WINDOWS = JSON.parse(data.GET_PERFIL_GRUPO_WINDOWS).Recordset0.Rows;
    let activate = false;
    let functionality = [];
    let gruposWindows = [];

    //Valido si se hizo o hubo error en la consulta de AD.
    if (data.GET_ALL_GROUPS_AD) {
        let ADResult = JSON.parse(data.GET_ALL_GROUPS_AD).Recordset0.Rows[0];        

        if (ADResult.IsError) {
            gruposWindows = [{ Id: 0, Descripcion: ADResult.Message, Selected: false }];
        }
        else {
            //Mapeo de grupos de AD.        
            ADResult = JSON.parse(ADResult.Result);
            ADResult.forEach((g, index) => {
                gruposWindows.push({ Id: index, Descripcion: g, Selected: false });
            });
        }
    }

    for (var i = 0; i < result.length; i++) {
        result[i].gruposWindows = JSON.parse(JSON.stringify(gruposWindows));
        result[i].gruposWindows.forEach(function (grupo) {
            GET_PERFIL_GRUPO_WINDOWS.forEach(function (existingRelation) {
                if (grupo.Descripcion == existingRelation.GrupoWindows && existingRelation.IdPerfil == result[i].Id)
                    grupo.Selected = true;
            });
        });
    }

    for (var i = 0; i < result.length; i++) {
        result[i].first = (i == 0);
        result[i].functions = [];
    }

    if (data.GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD) {
        functionality = JSON.parse(data.GET_PERMISO_FUNCIONALIDAD_BY_FUNCIONALIDAD).Recordset0.Rows;
        activate = true;
    }

    if (functionality.length > 0) {
        result.forEach(function (perfil) {
            perfil.functions = functionality.filter(x => x.PerfilId == perfil.Id);
        });
    }
    else {
        result.forEach(function (perfil) {
            perfil.functions = [];
        });
    }

    let response = {
        perfiles: result,
        activate
    }

    _dispatch({ type: EDIT_PERFIL_RESULT, response });
}


/** 
 * Callback de llamado a Sagas en el alta de perfil
 * @param {any} result
 * @param {any} disconectCallback
 */
function ejecutarPorEstado(result, disconectCallback) {
    switch (result.Estado) {
        case 2:
            _perfiProductoCallback();

            break;

        case 3:
            HandleErrorSaga();

            break;

        case 5:
            HandleErrorSaga();

            break;

        default:
            HandleErrorSaga();

            break;
    }

    disconectCallback();
}

/**
 * Callback de llamado a Sagas en la eliminacion de perfil
 * @param {any} result
 * @param {any} disconectCallback
 * @param {any} descripcion
 */
function ejecutarPorEstadoDelete(result, disconectCallback, descripcion) {
    switch (result.Estado) {
        case 2:
            _eliminarPerfilCallback(descripcion);

            break;

        case 3:
            HandleErrorSaga();

            break;

        case 5:
            HandleErrorSaga();

            break;

        default:
            HandleErrorSaga();

            break;
    }

    disconectCallback();
}

/**
 * Callback de llamado a Sagas en la edicion de perfil
 * @param {any} result
 * @param {any} disconectCallback
 * @param {any} state
 */
function ejecutarPorEstadoEdit(result, disconectCallback, state) {
    switch (result.Estado) {
        case 2:
            _editarPerfilCallback(state);

            break;

        case 3:
            HandleErrorSaga();

            break;

        case 5:
            HandleErrorSaga();

            break;

        default:
            HandleErrorSaga();

            break;
    }

    disconectCallback();
}

/**
 * A ejecutarse cuando una saga falla con msje genérico
 */
function HandleErrorSaga() {
    let message = {
        value: "Hubo un error al procesar la transacci\u00F3n.",
        class: "error"
    };

    _dispatch({ type: SET_POP_UP_PERFYPERM, message });
}